module.exports = __webpack_public_path__ + "img/03.0d029455.jpg";